import $ from 'jquery';

if($('body,html').width() <= 1024) {
    $('.notification').find('.notification__chevron').addClass('rotate');
    $('.notification').prop('open', false);
}

$('.notification__header').on('click', function() {
    $(this).find('svg').toggleClass('rotate');
});